import React from 'react';

class Linkedin {
	welcome_pixel() {
		if (IS_AKTIEDYSTEN_DK) {
			return (
				<React.Fragment>
					<img height="1" width="1" style={{display:"none"}} alt="" src="https://px.ads.linkedin.com/collect/?pid=3460057&conversionId=3986994&fmt=gif" />
				</React.Fragment>
			);
		} else {
			return null;
		}
	}
}

export default new Linkedin();




// WEBPACK FOOTER //
// ./src/Linkedin.js